import React from "react";

import { useOtpRegister } from "./useOtpRegister.tsx";
import OtpRegisterUI from "./OtpRegister.ui.tsx";

const OtpRegister: React.FC = () => {
  const otpRegisterProps = useOtpRegister();

  return <OtpRegisterUI {...otpRegisterProps} />;
};

export default OtpRegister;
